import { render } from "./payout-order-header-list.vue?vue&type=template&id=3da5939a&ts=true"
import script from "./payout-order-header-list.ts?vue&type=script&lang=ts"
export * from "./payout-order-header-list.ts?vue&type=script&lang=ts"

import "./payout-order-header-list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__